var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.$store.state.lootbox === 0)?_c('div',{staticClass:"lootbox-bg"}):_c('div',{staticClass:"lootbox-bg2"}),_c('LootboxHero'),(_vm.$store.state.token !== null)?_c('LootboxContent'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }